import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for merging class names with Tailwind CSS.
 * This function wraps external libraries (twMerge and clsx).
 *
 * Moved from @repo/ui/lib/utils to consolidate utilities in the common package.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
